import React from 'react';
import { Body, Box } from '@hover/blueprint';
import type { BoxProps } from '@hover/blueprint';

interface IPartnersIntroCard extends BoxProps {
  color: string;
  logo?: React.ReactNode;
  description: string;
}
const PartnersIntroCard: React.FC<IPartnersIntroCard> = ({
  color,
  logo,
  description,
  children,
  ...boxProps
}) => (
  <Box
    borderWidth="2px 0 0 0"
    borderColor={color}
    borderRadius={10}
    py={8}
    px={10}
    d="block"
    textAlign={{ base: 'center', desktop: 'left' }}
    bg="linear-gradient(180deg, #F9FCFF 0%, #FCFDFF 100%)"
    w={{ base: '100%', desktop: 512 }}
    position={{ desktop: 'absolute' }}
    mt={{ base: 7, desktop: 'unset' }}
    {...boxProps}
  >
    {logo && (
      <Box mb={5} justifyContent={{ base: 'center', desktop: 'flex-start' }}>
        {logo}
      </Box>
    )}
    <Body size={500} mb={5} fontWeight={300}>
      {description}
    </Body>
    {children}
  </Box>
);

export default PartnersIntroCard;
